import { logout } from "./auth";

export class AuthenticationError extends Error {
  constructor(...params) {
    // Pass remaining arguments (including vendor specific ones) to parent constructor
    super(...params);

    // Maintains proper stack trace for where our error was thrown (only available on V8)
    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, AuthenticationError);
    }

    this.name = "AuthenticationError";
    // Custom debugging information
    //   this.foo = foo;
    this.date = new Date();
  }
}

export const AuthenticationErrorHandler = error => {
  if (error instanceof AuthenticationError) {
    logout();
    return "Please login to continue.";
  }
};
